<div class="listen-record">
  <button class="common-button__icon-xs-noborder"
    (click)="handleAccept('')">
      <i class="lf-icon-close-thick common-icon__sm"></i>
  </button>
  <div class="listen-record__body-container">
    <div class="listen-record__container-play">
      @if (!isLanding) {
        <button class="common-button__icon-lg"
          (click)="playRecordVoice()">
          <i class="common-icon__md"
            [ngClass]="startAudio?'lf-icon-stop':'lf-icon-play'">
          </i>
        </button>
      
      } @else {
          <button class="common-button__icon-lg"
          [ngStyle]="{'background-color':custom.color, 'color': custom.textColor}">
          <i class="common-icon__md"
            [ngClass]="startAudio?'lf-icon-stop':'lf-icon-play'">
          </i>
        </button>
      }
      <div class="record-audio-modal__container-progress-block w-[100%]">
        <div class="record-audio-modal__progress-text-container">
          <p class="record-audio-modal__progress-text record-audio-modal__progress-text--bold">
            {{recordedTime}}
          </p>
          <p class="record-audio-modal__progress-text">
            {{voiceRecord.maxTime}}
          </p>
        </div>
        <div class="common-progress-indicator__bar-block h-[4px]">
          <div class="common-progress-indicator__bar-inner"
            [progressBar]="percentTime">
          </div>
        </div>
      </div>
    </div>
    <div class="listen-record__container-buttons">
      <button class="common-button__icon-sm-noborder"
        (click)="audioDownLoad()">
          <i class="lf-icon-download common-icon__md"></i>
      </button>
      @if (!voiceRecord.noDelete) {
        <button class="common-button__icon-sm-noborder"
          (click)="handleAccept('delete')">
            <i class="lf-icon-trash common-icon__md"></i>
        </button>
      }

    </div>
  </div>
</div>
